import { render } from "./CommonScroll.vue?vue&type=template&id=2f7900d9"
import script from "./CommonScroll.vue?vue&type=script&lang=js"
export * from "./CommonScroll.vue?vue&type=script&lang=js"

import "./CommonScroll.vue?vue&type=style&index=0&id=2f7900d9&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__